export default {
  form: {
    versions: {
      label: 'Versie',
      placeholder: 'Versie selecteren',
    },
    font_family: {
      label: 'Lettertype',
    },
    background_color: {
      label: 'Achtergrondkleur',
    },
    promo_frame_primary_color: {
      label: 'Promorandkleur',
    },
    promo_frame_discount_label_color: {
      label: 'Promorand kortingskleur',
    },
    vip_members_cta_color: {
      label: 'VIP-leden CTA-kleur',
    },
    url_cta_color: {
      label: 'URL CTA-kleur',
    },
    url_color: {
      label: 'URL-kleur',
    },
    url_type: {
      label: 'URL',
      placeholder: 'URL selecteren',
    },
    url: {
      placeholder: 'www.example.com',
    },
    qr_code_border_color: {
      label: 'QR-code randkleur',
    },
    qr_code_background_color: {
      label: 'QR-code achtergrondkleur',
    },
    footer_background_color: {
      label: 'Voettekst achtergrondkleur',
    },
    logo_zoom: {
      label: 'Logogrootte',
    },
    logo: {
      label: 'Logo',
    },
  },
  toasts: {
    failed_to_load_data: 'Sticker laden mislukt',
  },
};
